import { Message } from "../message.model";

export interface BodyDateAnalysis {
  fecha: string[];
  acceso: string[];
  sucursal: string;
}

export interface ResponseDateAnalysis {
  [key: string]: DateAnalysisData | Message;
}

export interface DateAnalysisData {
  fechas: AnalysisData[];
  resumen: DateAnalysisSummary;
}

export interface AnalysisData {
  Dia: string;
  [key: string]: string |  number;
  orden: number;
}

export interface DateAnalysisSummary {
  total_visitantes: number;
}

export interface DateAnalysisMessage {
  mensaje: string;
}
